import portalCommunication from '@3plearning/mathletics-portal-communication-service';

export default class PortalCommunication {
    static Configure() {
        portalCommunication.requestLoadingSpinner(false);
    }

    // invoke this method to let the 3p-portal know
    // that we want to navigate to current module landing screen
    static navigateToLandingScreen(moduleName = '') {
        portalCommunication.requestNavigateToLanding(moduleName);
    }

    static serverError(error) {
        portalCommunication.requestServerError(error);
    }
}



// WEBPACK FOOTER //
// ./app/portal-comms.js